import axios from 'axios'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/b2c/sso`

async function getClientDomain(clientReference: string) {
  const response = await axios({
    method: 'get',
    url: BASE_URL.concat(`/lookupClient`),
    headers: {
      'Jyrney-API-Key': `${clientReference}`,
    },
  })
  return response
}

async function getMobileClient(origin: string) {
  try {
    const response = await axios({
      method: 'get',
      url: encodeURI(BASE_URL.concat(`/lookupMobileClient`)),
      params: { origin: origin },
      headers: {
        'Jyrney-API-Key': `${process.env.REACT_APP_REDIRECT_LOOKUP}`,
      },
    })
    return response
  } catch (err) {
    console.log(err)
  }
}

export const ssoAPI = {
  getClientDomain,
  getMobileClient,
}
